var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardinActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_980_2629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3156 24.5499C29.8217 22.6609 29.8865 20.6807 29.505 18.7626C29.1235 16.8445 28.3058 15.0398 27.1153 13.4883C25.9247 11.9367 24.3932 10.6799 22.6392 9.81487C20.8852 8.94989 18.9557 8.5 17 8.5C15.0443 8.5 13.1148 8.94989 11.3608 9.81487C9.60681 10.6799 8.07529 11.9367 6.88474 13.4883C5.69419 15.0398 4.87652 16.8445 4.49499 18.7626C4.11345 20.6807 4.17828 22.6609 4.68445 24.5499",
    stroke: "#3C4469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0845 22.0748C18.7751 23.0798 18.2894 24.6128 16.9998 25.4991C15.7101 26.3853 14.1048 26.2891 13.4143 25.2842C12.6171 24.1241 9.70247 17.155 8.23218 13.5883C8.0279 13.0928 8.63431 12.676 9.02369 13.0444C11.8262 15.6955 17.2873 20.9148 18.0845 22.0748Z",
    stroke: "#3C4469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5V11.3333",
    stroke: "#3C4469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98438 12.2339L9.98784 14.2374",
    stroke: "#3C4469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0156 12.2339L24.0122 14.2374",
    stroke: "#3C4469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3154 24.5496L26.5786 23.8162",
    stroke: "#3C4469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68457 24.5496L7.42136 23.8162",
    stroke: "#3C4469",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_980_2629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardinActive);
export default __webpack_public_path__ + "static/media/DashboardinActive.39343d9966a44e5b711e48aed3c19363.svg";
export { ForwardRef as ReactComponent };